import { useUserQuery } from '~/lib/api/modules/Users/hooks/useUserQuery';

export const TERMS_OF_SERVICES_CURRENT_VERSION = '20250804125623';

type ITermsOfServicesAcceptationStatus = 'required' | 'accepted' | 'none';

export const useTermsOfServicesAcceptationStatus =
  (): ITermsOfServicesAcceptationStatus => {
    const userQuery = useUserQuery({});

    if (!userQuery.isFetched || !userQuery.data || userQuery.isError) {
      return 'none';
    }

    const optInIds = !userQuery.data?.optInIds ? [] : userQuery.data?.optInIds;

    if (!optInIds.includes(TERMS_OF_SERVICES_CURRENT_VERSION)) {
      return 'required';
    }

    return 'accepted';
  };
